// =====================================================================
// Meta Pixel helpers — safe wrappers around window.fbq
// =====================================================================
// The pixel itself is initialized in App.tsx. These helpers just fire
// the standard Meta events for tracking funnel steps.

type FBQ = (
  command: 'track' | 'init' | 'trackCustom',
  event: string,
  params?: Record<string, unknown>,
) => void

function getFbq(): FBQ | null {
  if (typeof window === 'undefined') return null
  const w = window as unknown as { fbq?: FBQ }
  return typeof w.fbq === 'function' ? w.fbq : null
}

// Fired when a user clicks one of the "QUIERO MI PACK" CTAs and leaves
// for the checkout page. Pass the product info so reporting in
// Events Manager is meaningful.
export function trackInitiateCheckout(params: {
  value: number
  currency?: string
  contentName?: string
  contentIds?: string[]
}) {
  const fbq = getFbq()
  if (!fbq) return
  fbq('track', 'InitiateCheckout', {
    value: params.value,
    currency: params.currency ?? 'ARS',
    content_name: params.contentName,
    content_ids: params.contentIds,
    content_type: 'product',
    num_items: 1,
  })
}

// Fired on the thank-you page AFTER a purchase is completed.
// NOTE: purchases happen on mamasincaos.store (external Shopify-like
// store), not on this landing page — so this helper is only useful if
// you embed a thank-you page back into this React app. Otherwise the
// Purchase event must be installed on the store's order-confirmation
// page directly.
export function trackPurchase(params: {
  value: number
  currency?: string
  contentName?: string
  contentIds?: string[]
}) {
  const fbq = getFbq()
  if (!fbq) return
  fbq('track', 'Purchase', {
    value: params.value,
    currency: params.currency ?? 'ARS',
    content_name: params.contentName,
    content_ids: params.contentIds,
    content_type: 'product',
    num_items: 1,
  })
}
